// extracted by mini-css-extract-plugin
export default {"root":"style_root__z7mWW","header":"style_header__NbePY","content":"style_content__aIGtR","icon":"style_icon__R25U9","active":"style_active__X6OZs"};